import { getActionTypeFromInstance } from '@ngxs/store';

export class ResetAllStates {
  static readonly type = '[Global State] Reset';
}

/**
 * This meta reducer is used to reset all states of the application.
 * Dispatch the ResetAllStates-action defined above, to trigger the reset!
 */

export function resetPlugin(state: any, action: any, next: any) {
  if (getActionTypeFromInstance(action) === ResetAllStates.type) {
    state = {};
  }
  return next(state, action);
}
